import { __awaiter, __decorate, __metadata } from "tslib";
import { inject, injectable, postConstruct } from 'mana-syringe';
import { XFlowGraphCommands } from '../constant';
import { ICommandHandler, ICommandContextProvider } from '../../command/interface';
export var NsGraphSaveData;
(function (NsGraphSaveData) {
    /** Command Id: 用于注册named factory */
    NsGraphSaveData.command = XFlowGraphCommands.SAVE_GRAPH_DATA;
    /** hookName */
    NsGraphSaveData.hookKey = 'saveGrpahData';
})(NsGraphSaveData || (NsGraphSaveData = {}));
let GraphSaveDataCommand = 
/** 创建节点命令 */
class GraphSaveDataCommand {
    constructor() {
        /** 执行Cmd */
        this.execute = () => __awaiter(this, void 0, void 0, function* () {
            const ctx = this.ctx;
            const args = ctx.getArgs();
            const hooks = ctx.getHooks();
            /** 执行hooks */
            yield hooks.saveGrpahData.call(
            /** 执行hooks pipeline处理args */
            args.args, 
            /** 执行 callback */
            (handlerArgs) => __awaiter(this, void 0, void 0, function* () {
                const { saveGraphDataService, includeAttrs } = handlerArgs;
                const x6Graph = yield ctx.getX6Graph();
                const x6Nodes = x6Graph.getNodes();
                const x6Edges = x6Graph.getEdges();
                const nodes = x6Nodes.map(node => {
                    const data = node.getData();
                    const position = node.position();
                    const size = node.size();
                    const model = Object.assign(Object.assign(Object.assign({ id: node.id }, data), position), size);
                    if (includeAttrs) {
                        model.attrs = node.getAttrs();
                    }
                    return model;
                });
                const edges = x6Edges.map(edge => {
                    const data = edge.getData();
                    const model = Object.assign({ id: edge.id }, data);
                    if (includeAttrs) {
                        model.attrs = edge.getAttrs();
                    }
                    return model;
                });
                const graphData = { nodes, edges };
                const graphMeta = yield this.ctx.getGraphMeta();
                /** 执行 service */
                if (saveGraphDataService) {
                    const result = yield saveGraphDataService(graphMeta, graphData);
                    /** 设置结果 */
                    if (result) {
                        this.ctx.setResult(result);
                    }
                }
                return {};
            }), 
            /** 外部的 hook */
            args.hooks);
            return this;
        });
        /** undo cmd */
        this.undo = () => __awaiter(this, void 0, void 0, function* () {
            this.ctx.undo();
            return this;
        });
        /** redo cmd */
        this.redo = () => __awaiter(this, void 0, void 0, function* () {
            if (!this.ctx.isUndoable) {
                yield this.execute();
            }
            return this;
        });
    }
    init() {
        this.ctx = this.contextProvider();
    }
    /** isUndoable */
    isUndoable() {
        return this.ctx.isUndoable();
    }
};
__decorate([
    inject(ICommandContextProvider),
    __metadata("design:type", Object)
], GraphSaveDataCommand.prototype, "contextProvider", void 0);
__decorate([
    postConstruct(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], GraphSaveDataCommand.prototype, "init", null);
GraphSaveDataCommand = __decorate([
    injectable({
        token: { token: ICommandHandler, named: NsGraphSaveData.command.id },
    })
    /** 创建节点命令 */
], GraphSaveDataCommand);
export { GraphSaveDataCommand };
//# sourceMappingURL=graph-save-data.js.map